import { useLottie } from "lottie-react";
import {
  BoldText,
  FlexBox,
  HoverEffect,
  InnerSection,
  PaddB,
  Padding,
  PaddT,
} from "../../component/GeneralStyledComponent";

import {
  Block,
  Border_box,
  C,
  Cursor_div,
  DescriptionText,
  Flex_Box,
  Flex_Con,
  GuideText,
  HeaderText,
  Inner_Section,
  Outter_Section,
  Section,
  SimpleBoldText,
  SocialButton,
} from "../../component/styledComponent";
import Fonts from "../../Customs/Fonts";
import Resource from "../../Resources/Resource";

export function FooterSection() {
  return (
    <>
      <Outter_Section>
        <Inner_Section color="black">
          <DescriptionText size="22px" >X-Pass communities</DescriptionText>
          <SimpleBoldText style={{fontWeight:"900"}}>Join the X-Pass Community</SimpleBoldText>
          <DescriptionText size="22px">
            Be the part of next generation community and leverage the benefit of
            x-pass
          </DescriptionText>
        </Inner_Section>
        <Inner_Section>{Socails()}</Inner_Section>
      </Outter_Section>
    </>
  );
}

export function Socails() {
  return (
    <>
      <Block>
        <Flex_Box style={{ gap: "100px", justifyContent: "center" }}>
          <Flex_Box>
            <Flex_Box>
              <SocialButton >
                <Flex_Box style={{padding:"10px 15px"}}>
                  <span>
                    {/* <img src={Resource.icons.discord} /> */}
                    <i
                      className="fab fa-discord"
                      style={{ fontSize: "26px" }}
                    ></i>
                  </span>
                  <span>
                    <DescriptionText>
                      Join our <b>Discord Server</b>
                    </DescriptionText>
                  </span>
                </Flex_Box>
              </SocialButton>
            </Flex_Box>
            <Border_box></Border_box>

            <Flex_Box>
              <SocialButton>
                <Flex_Box>
                  {/* <img src={Resource.icons.twitter} />
                   */}
                  <i
                    className="fab fa-twitter"
                    style={{ fontSize: "26px" }}
                  ></i>
                  <DescriptionText>
                    Twitter.com/<b>X-Pass</b>
                  </DescriptionText>
                </Flex_Box>
              </SocialButton>
            </Flex_Box>
          </Flex_Box>
        </Flex_Box>
      </Block>
    </>
  );
}

export function EndingFooter() {
  return (
    <>
      <Flex_Box style={{ color: "white", justifyContent: "center",background:"black " }}>
        <DescriptionText style={{ margin: "5px", fontWeight: "700" }}>
          Developed with <span style={{ color: "red" }}>&#10084;</span> by
          Developer
        </DescriptionText>
      </Flex_Box>
    </>
  );
}

export function Footer() {
  return (
    <>
      <Outter_Section>
        <InnerSection>
          <FlexBox
            style={{
              justifyContent: "space-between",
              borderBottom: "solid 1px black",
            }}
          >
            <FlexBox
              style={{
                margin: 0,
                alignItems: "flex-start",
                padding: "50px 0 ",
              }}
            >
              <Block>
                <BoldText fs="42px">
                  We love <C col="#EEB27B">People</C> and
                </BoldText>
                <BoldText fs="42px">
                  the <C col="#B04CD3">NFT</C> that are meant
                </BoldText>
                <BoldText fs="42px">
                  {" "}
                  for <C col="#81A2EF">Commununity</C> benefit
                </BoldText>

                <PaddT>
                  <HoverEffect>
                    <i
                      className="fab fa-discord"
                      style={{
                        fontSize: "26px",
                        margin: "0 20px 0 0 ",
                        color: "#7289da",
                      }}
                    ></i>
                  </HoverEffect>
                  <HoverEffect>
                    <i
                      className="fab fa-twitter"
                      style={{ fontSize: "26px", color: "#00acee " }}
                    ></i>
                  </HoverEffect>
                </PaddT>
              </Block>
            </FlexBox>

            <FlexBox style={{ margin: 0, alignItems: "baseline" }}>
              <FlexBox
                style={{
                  flexWrap: "wrap",
                  padding: "60px 0",
                  alignItems: "baseline",
                }}
              >
                <Block>
                  <Padding padd="4px">
                    <GuideText>Company</GuideText>
                    <DescriptionText>About </DescriptionText>
                  </Padding>
                </Block>
                <Block>
                  <Padding padd="4px">
                    <GuideText>Support</GuideText>
                    <DescriptionText>Contact us</DescriptionText>
                  </Padding>
                </Block>
              </FlexBox>
            </FlexBox>
          </FlexBox>
          <FlexBox>
            <Padding pad="15px 0 ">
              <BoldText fs="25px">X-PASS</BoldText>
            </Padding>
          </FlexBox>

          <FlexBox>
            <DescriptionText>© 2023, X-PASS</DescriptionText>
          </FlexBox>
        </InnerSection>
      </Outter_Section>
    </>
  );
}

export function SubmitUX() {
  const options = {
    animationData: Resource.Animation.submited,
    loop: true,
  };
  const { View } = useLottie(options);

  return (
    <>
      <Block
        maxW="280px"
        height="434px"
        display="flex"
        style={{ backgroundColor: "white" }}
      >
        <Flex_Box
          style={{ width: "60%", flexFlow: "column", justifyContent: "center" }}
        >
          {View}
          <DescriptionText>Subscribed</DescriptionText>
        </Flex_Box>
      </Block>
    </>
  );
}
